import { render, staticRenderFns } from "./relateInterfaceForm.vue?vue&type=template&id=501bdf1f&"
import script from "./relateInterfaceForm.vue?vue&type=script&lang=js&"
export * from "./relateInterfaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "relateInterfaceForm.vue"
export default component.exports